<label class="searchbox" [class.dirty]="!!searchInput.value">
  <!-- [placeholder]="'searchBox.placeholder' | cxTranslate" -->

  <input
    #searchInput
    [placeholder]="'Search here...'"
    aria-label="search"
    (focus)="open()"
    (input)="search(searchInput.value)"
    (blur)="close($event)"
    (keydown.escape)="close($event)"
    (keydown.enter)="close(true); launchSearchResult(searchInput.value); updateChosenWord(searchInput.value)"
    (keydown.arrowup)="focusPreviousChild($event)"
    (keydown.arrowdown)="focusNextChild($event)"
    value="{{ chosenWord }}"
    />

    <cx-icon
      [type]="iconTypes.RESET"
      aria-label="reset"
      (mousedown)="clear(searchInput)"
      (keydown.enter)="clear(searchInput)"
      class="reset"
      tabindex="0"
    ></cx-icon>

    <cx-icon
      [type]="iconTypes.SEARCH"
      aria-label="search"
      class="search"
      (mousedown)="avoidReopen($event)"
      (keydown.enter)="avoidReopen($event)"
      tabindex="0"
    ></cx-icon>
  </label>

  @if (results$ | async; as result) {
    <div class="results" (click)="close($event, true)">
      @if (result.message) {
        <div class="message" [innerHTML]="result.message"></div>
      }
      <div class="suggestions">
        <ul class="suggestions" attr.aria-label="{{ 'searchBox.ariaLabelSuggestions' | cxTranslate }}" role="listbox">
          @for (suggestion of result.suggestions; track suggestion) {
            <li>
              <a
                role="option"
                [innerHTML]="suggestion | cxHighlight: searchInput.value"
          [routerLink]="
            {
              cxRoute: 'search',
              params: { query: suggestion }
            } | cxUrl
          "
                (keydown.arrowup)="focusPreviousChild($any($event))"
                (keydown.arrowdown)="focusNextChild($any($event))"
                (keydown.enter)="close($any($event), true)"
                (keydown.escape)="close($any($event), true)"
                (blur)="close($event)"
                (mousedown)="preventDefault($event)"
                >
              </a>
            </li>
          }
        </ul>
      </div>
      @if (result.spellingSuggestion) {
        <div class="suggestions">
          <a
            [innerHTML]="result.spellingSuggestion.query"
      [routerLink]="
        {
          cxRoute: 'search',
          params: { query: result.spellingSuggestion.suggestion }
        } | cxUrl
      "
            (keydown.arrowup)="focusPreviousChild($event)"
            (keydown.arrowdown)="focusNextChild($event)"
            (keydown.enter)="close($event, true)"
            (keydown.escape)="close($event, true)"
            (blur)="close($event)"
            >
          </a>
        </div>
      }
      <div>
        @if (result.products) {
          <ul
            class="products"
            attr.aria-label="{{ 'searchBox.ariaLabelProducts' | cxTranslate }}"
            role="listbox"
            >
            @for (product of result.products; track product) {
              <li>
                <a
                  role="option"
          [routerLink]="
            {
              cxRoute: 'product',
              params: product
            } | cxUrl
          "
                  [class.has-media]="config.displayProductImages"
                  (keydown.arrowup)="focusPreviousChild($any($event))"
                  (keydown.arrowdown)="focusNextChild($any($event))"
                  (keydown.enter)="close($any($event), true)"
                  (keydown.escape)="close($any($event), true)"
                  (mousedown)="preventDefault($event)"
                  (blur)="close($event)"
                  >
                  <!-- TODO AC-1260 remove following from cx-media
                  [alt]="product.summary" -->
                  @if (config.displayProductImages) {
                    <cx-media
                      [container]="product.images?.PRIMARY"
                      format="thumbnail"
                    ></cx-media>
                  }
                  <h4 class="name" [innerHTML]="product.nameHtml"></h4>
                  @if (userPermissionService.showPrice) {
                    <span class="price">{{ product.price?.formattedValue }}</span>
                  }
                </a>
              </li>
            }
          </ul>
        }
      </div>
    </div>
  }
